import styled from "styled-components";

export const Container = styled.div`
    background: transparent;
`;
export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 12px;
    user-select: none;
`;
export const Title = styled.div`
    background: transparent;
`;

export const ContentWrapper = styled.div<{ "data-open": boolean }>`
    overflow: hidden;
    display: grid;
    grid-template-rows: ${({ ["data-open"]: open }) => (open ? "1fr" : "0fr")};
    transition: grid-template-rows 200ms ease;
`;
export const ContentInner = styled.div<{ "data-open": boolean }>`
    overflow: hidden;
    transition: padding 200ms ease;
`;
